import { render, staticRenderFns } from "./NotificationListCard.vue?vue&type=template&id=6facad7e&scoped=true"
import script from "./NotificationListCard.vue?vue&type=script&lang=js"
export * from "./NotificationListCard.vue?vue&type=script&lang=js"
import style0 from "./NotificationListCard.vue?vue&type=style&index=0&id=6facad7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6facad7e",
  null
  
)

export default component.exports